export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/sleep-blueberry.4c08b7b0b460cc7a3bc9f6ddf7107552.png";